// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"07a84412","466":"02b3450b","529":"c53199f9","628":"4c6e5628","663":"646fd6eb","737":"655cf195","748":"f6396df8","779":"58105daf"}[chunkId] + ".chunk.js";
};